const DISABLE_COOKIES_LINKS_FROM_STEP_1 = [
  {
    name: 'Google Chrome',
    url: 'https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=pt-BR',
  },
  {
    name: 'Mozilla Firefox',
    url: 'https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento',
  },
  {
    name: 'Safari',
    url: 'https://support.apple.com/pt-br/guide/safari/sfri11471/mac',
  },
  {
    name: 'Microsoft Edge',
    url: 'https://support.microsoft.com/pt-br/microsoft-edge/excluir-cookies-no-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09',
  },
]

const DISABLE_COOKIES_STEPS = [
  {
    step: 2,
    stepKey: 'two',
  },
  {
    step: 3,
    stepKey: 'three',
  },
  {
    step: 4,
    stepKey: 'four',
  },
  {
    step: 5,
    stepKey: 'five',
  },
  {
    step: 6,
    stepKey: 'six',
  },
  {
    step: 7,
    stepKey: 'seven',
  },
  {
    step: 8,
    stepKey: 'eight',
  },
  {
    step: 9,
    stepKey: 'nine',
  },
  {
    step: 10,
    stepKey: 'ten',
  },
]

const disableCookies = {
  DISABLE_COOKIES_LINKS_FROM_STEP_1,
  DISABLE_COOKIES_STEPS,
}

export default disableCookies
